import React, { useState, useEffect } from 'react';
import {
    Send,
    CheckCircle2,
    ArrowRight,
    Mail,
    Phone
} from 'lucide-react';
import './BookNow.css';

const BookNow = () => {
    const [submitted, setSubmitted] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        company: '',
        source: '',
        message: ''
    });

    useEffect(() => {
        document.title = "Book a Demo | X-Max Manufacturing Excellence";
        window.scrollTo(0, 0);
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Simulate API call
        console.log('Form Data:', formData);
        setSubmitted(true);
    };

    if (submitted) {
        return (
            <div className="book-now-page success-view">
                <div className="container">
                    <div className="success-content">
                        <CheckCircle2 size={80} className="success-icon" />
                        <h1>Thank You, {formData.name.split(' ')[0]}!</h1>
                        <p>Your demo request has been received. Our excellence team will reach out to you at <strong>{formData.email}</strong> within 24 hours.</p>
                        <button className="btn btn-primary" onClick={() => window.location.href = '/'}>
                            Back to Home <ArrowRight size={18} />
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="book-now-page">
            <div className="container book-now-container">
                <div className="book-now-header">
                    <div className="sec-tag">TRANSFORM NOW</div>
                    <h1>Book Your <span className="gradient-text">X-Max Demo</span></h1>
                    <p>Experience the future of manufacturing. See how X-Max can digitize your operations and drive measurable excellence.</p>

                    <div className="contact-quick-list">
                        <div className="contact-item">
                            <Mail size={20} />
                            <span>excellence@x-max.com</span>
                        </div>
                        <div className="contact-item">
                            <Phone size={20} />
                            <span>+1 (555) 000-XMAX</span>
                        </div>
                    </div>
                </div>

                <div className="form-wrapper">
                    <form onSubmit={handleSubmit} className="booking-form">
                        <div className="form-grid">
                            <div className="form-group">
                                <label>Full Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Enter your name"
                                    required
                                    value={formData.name}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <label>Work Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="email@company.com"
                                    required
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <label>Phone No.</label>
                                <input
                                    type="tel"
                                    name="phone"
                                    placeholder="+1 (555) 000-0000"
                                    required
                                    value={formData.phone}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <label>Company Name</label>
                                <input
                                    type="text"
                                    name="company"
                                    placeholder="Your Organisation"
                                    required
                                    value={formData.company}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="form-group full-width">
                            <label>How did you hear about us?</label>
                            <select
                                name="source"
                                required
                                value={formData.source}
                                onChange={handleChange}
                            >
                                <option value="" disabled>Select an option</option>
                                <option value="search">Search Engine (Google, Bing)</option>
                                <option value="social">Social Media (LinkedIn, Twitter)</option>
                                <option value="referral">Referral / Word of Mouth</option>
                                <option value="event">Industry Event / Webinar</option>
                                <option value="other">Other</option>
                            </select>
                        </div>

                        <div className="form-group full-width">
                            <label>Message / Specific Requirements</label>
                            <textarea
                                name="message"
                                placeholder="Tell us about your production challenges..."
                                rows="4"
                                value={formData.message}
                                onChange={handleChange}
                            ></textarea>
                        </div>

                        <button type="submit" className="btn btn-primary btn-lg submit-btn">
                            Request My Demo <Send size={20} />
                        </button>
                    </form>
                </div>
            </div>

            <div className="book-now-bg-glow"></div>
        </div>
    );
};

export default BookNow;
